var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2500 2500",
    style: {
      enableBackground: "new 0 0 2500 2500"
    },
    width: 25,
    height: 24,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#DC2626;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2188286487584"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1250,0L1250,0c688,0,1250,563,1250,1250l0,0c0,688-563,1250-1250,1250l0,0C562,2500,0,1937,0,1250l0,0    C0,562,563,0,1250,0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1995,1226l-225-76c-83-28-144-97-161-182l-95-466c-3-12-13-20-25-20s-23,9-25,20l-95,466      c-17,85-79,154-161,182l-225,76c-10,3-17,13-17,24s7,21,17,24l225,76c83,28,144,97,161,182l95,466c3,12,13,20,25,20s23-9,25-20      l95-466c17-85,79-154,161-182l225-76c10-3,17-13,17-24S2005,1229,1995,1226z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M788,799l79,27c29,10,51,34,57,64l33,164c1,4,4,7,9,7c4,0,8-3,9-7l33-164c6-30,28-54,57-64l79-27      c3-1,6-5,6-9s-3-7-6-9l-79-27c-29-10-51-34-57-64l-33-164c-1-4-4-7-9-7c-4,0-8,3-9,7l-33,164c-6,30-28,54-57,64l-79,27      c-3,1-6,5-6,9S785,797,788,799z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M973,1607l-106-36c-39-13-68-46-76-86l-45-220c-1-6-6-10-12-10s-11,4-12,10l-45,220c-8,40-37,73-76,86      l-106,36c-5,2-8,6-8,11s3,10,8,11l106,36c39,13,68,46,76,86l45,220c1,6,6,9,12,9s11-4,12-9l45-220c8-40,37-73,76-86l106-36      c5-2,8-6,8-11S978,1608,973,1607z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagic);
export default __webpack_public_path__ + "static/media/magic.61f3daa3b5a462e7aba765d2b3683215.svg";
export { ForwardRef as ReactComponent };